
import React from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { IMAGE_URL } from '../../services/api';
import ProtectedImage from '../../components/ProtectedImage';

const TaskView =({ show, handleClose, selectedTask, category = "task"})=>{

    // const baseUrl = 'http://localhost:8000';  
      return (
        <Modal show={show} onHide={handleClose} centered size="lg">
          <Modal.Header closeButton>
          <Modal.Title>
          {category?.toLowerCase() === "issue" ? "Issue Details" : "Task Details"}
          </Modal.Title>

          </Modal.Header>
          <Modal.Body>
            {selectedTask && (
              <Container>
                <Row className="mb-2">
                <Col><strong> Category :</strong> {selectedTask.category}</Col>
                </Row>
                <Row className="mb-2">
                <Col><strong>Project:</strong> {selectedTask.project.title}</Col>
                </Row>
                <Row className="mb-2">
                <Col><strong>Title:</strong> {selectedTask.title}</Col>
                </Row>
                <Row className="mb-2">
                <Col> <strong> Descripation:</strong> {selectedTask.description} </Col>
                </Row>
                <Row className="mb-2">
                <Col> <strong> Assigned To:</strong>{selectedTask.assigned_to?.first_name} {selectedTask.assigned_to?.last_name}</Col>
                </Row>
                <Row className="mb-2">
                <Col> <strong> Start Date:</strong>{selectedTask.start_date}</Col>
                </Row>
                <Row className="mb-2">
                 <Col><strong> End Date:</strong> {selectedTask.end_date} </Col>
                </Row>
                <Row className="mb-2">
                 <Col><strong> Created At:</strong> {selectedTask.created_at} </Col>
                </Row>
                <Row className="mb-2">
                <Col>
                    <strong>Priority:</strong>{' '}
                    <span
                    style={{
                        color:
                        selectedTask.priority === "Low"
                            ? "#8BC34A"
                            : selectedTask.priority === "Medium"
                            ? "#FFC107"
                            : selectedTask.priority === "High"
                            ? "#FF5722"
                            : selectedTask.priority === "Critical"
                            ? "#dc3545"
                            : "black",
                        fontWeight: 'bold'
                    }}
                    >
                    {selectedTask.priority}
                    </span>
                </Col>
                </Row>

                <Row className="mb-2">
                <Col>
                    <strong>Status:</strong>{' '}
                    <span
                    style={{
                        color:
                        selectedTask.status === "New"
                            ? "#2196F3"
                            : selectedTask.status === "Pending"
                            ? "#FF9800"
                            : selectedTask.status === "In Progress"
                            ? "#9C27B0"
                            : selectedTask.status === "Completed"
                            ? "#4CAF50"
                            : "black",
                        fontWeight: 'bold'
                    }}
                    >
                    {selectedTask.status}
                    </span>
                </Col>
                </Row>

                <strong>Attachments:</strong>
                {selectedTask.attachments.map((url, index) => {
                const fullUrl = `${IMAGE_URL}${url}`; // Build the full URL
                const isPDF = fullUrl.toLowerCase().endsWith('.pdf');
                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fullUrl);
    
                return (
                    <div key={index}>
                    {isImage ? (
                        // <img
                        // src={fullUrl}
                        // alt={`Attachment ${index + 1}`}
                        // style={{
                        //     width: '100px',
                        //     height: '100px',
                        //     objectFit: 'cover',
                        //     borderRadius: '8px',
                        //     cursor: 'pointer',
                        // }}
                        // onClick={() => window.open(fullUrl, '_blank')}
                        // />
                        <ProtectedImage
  path={fullUrl}
  alt={`Attachment ${index + 1}`}
  style={{
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    cursor: "pointer",
  }}
  onClick={() => window.open(fullUrl, "_blank")}
/>

                    ) : isPDF ? (
                        <p
                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => window.open(fullUrl, '_blank')}
                        >
                        View PDF {index + 1}
                        </p>
                    ) : (
                        <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                        Download File {index + 1}
                        </a>
                    )}
                    </div>
                );
                })}            
              </Container>
            )}
          </Modal.Body>
        </Modal>
      );

}

export default TaskView;